/* <vc-carousel>: scroll-snap track with arrows and a progress bar. Markup:
   <vc-carousel><div class="vc-carousel__track" style="--per:5">...</div>
     <div class="vc-carousel__foot"><div class="vc-carousel__bar"><span></span></div>
       <div class="vc-carousel__nav"><button class="vc-icon-btn" data-prev>..</button><button class="vc-icon-btn" data-next>..</button></div></div></vc-carousel> */
if (!customElements.get('vc-carousel')) {
  customElements.define('vc-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vc-carousel__track');
      if (!this.track) return;
      this.bar = this.querySelector('.vc-carousel__bar span');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      const step = (dir) => {
        const item = this.track.children[0];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 12;
        const w = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        // whole cards in view: (width + one gap) / (card + gap). Flooring width / (card + gap) came out one short (4 of 5).
        const per = Math.max(1, Math.floor((this.track.clientWidth + gap) / w + 0.01));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * w * per, behavior: reduce ? 'auto' : 'smooth' });
      };
      this.prev && this.prev.addEventListener('click', () => step(-1));
      this.next && this.next.addEventListener('click', () => step(1));
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() { window.removeEventListener('resize', this.update); }
    update() {
      const t = this.track; const max = t.scrollWidth - t.clientWidth;
      const visible = t.scrollWidth ? t.clientWidth / t.scrollWidth : 1;
      if (this.bar) {
        this.bar.style.width = Math.max(8, visible * 100) + '%';
        const pos = max > 0 ? t.scrollLeft / max : 0;
        this.bar.style.transform = `translateX(${pos * (100 / Math.max(visible, .01) - 100)}%)`;
      }
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      const foot = this.querySelector('.vc-carousel__foot');
      if (foot) foot.hidden = max <= 2;
    }
  });
}
